'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PackageSelectionCardHeader = require('../../../../common/views/PackageSelection/PackageSelectionCardHeader.js');
var PackageSelectionCardItems = require('../../../../common/views/PackageSelection/PackageSelectionCardItems.js');
var PackageSelectionIneligibilityReason = require('../../../../common/views/PackageSelection/PackageSelectionIneligibilityReason.js');
var DetailsCard = require('../../../../common/components/DetailsCard/DetailsCard.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PackageSelectionCardUnselected = _ref => {
  let {
    shipment,
    disabled
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(PackageSelectionCardHeader["default"], {
    shipment: shipment
  }), /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardAttributesContainer, {
    wideGap: true
  }, /*#__PURE__*/React__default["default"].createElement(PackageSelectionIneligibilityReason["default"], {
    shipment: shipment
  }), !disabled ? /*#__PURE__*/React__default["default"].createElement(PackageSelectionCardItems["default"], {
    shipment: shipment
  }) : /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      width: '100%',
      opacity: 0.5
    }
  }, /*#__PURE__*/React__default["default"].createElement(PackageSelectionCardItems["default"], {
    shipment: shipment
  }))));
};

exports["default"] = PackageSelectionCardUnselected;
